import { Recipe, ScrapedProduct } from './types';

export const sampleRecipes: Recipe[] = [
  {
    id: 'lentil-tomato-stew',
    name: 'Lentil tomato stew',
    mealTypes: ['dinner', 'lunch'],
    baseServings: 4,
    prepMinutes: 10,
    cookMinutes: 28,
    ingredients: [
      { ingredientId: 'red-lentils', name: 'Red lentils', quantity: 300, unit: 'g', category: 'pantry' },
      { ingredientId: 'tinned-tomatoes', name: 'Tinned tomatoes', quantity: 800, unit: 'g', category: 'pantry' },
      { ingredientId: 'onion', name: 'Onion', quantity: 1, unit: 'count', category: 'produce' },
      { ingredientId: 'carrot', name: 'Carrot', quantity: 2, unit: 'count', category: 'produce' },
      { ingredientId: 'rice', name: 'Rice', quantity: 280, unit: 'g', category: 'pantry' },
    ],
    tags: ['#batch-friendly', '#ultra-cheap', '#freezer-friendly'],
    dietaryTags: ['vegan', 'vegetarian', 'gluten-free'],
    styleTags: ['batch-prep', 'leftover-rotation'],
  },
  {
    id: 'chickpea-curry',
    name: 'Chickpea coconut curry',
    mealTypes: ['dinner', 'lunch'],
    baseServings: 4,
    prepMinutes: 12,
    cookMinutes: 24,
    ingredients: [
      { ingredientId: 'chickpeas', name: 'Chickpeas', quantity: 480, unit: 'g', category: 'pantry' },
      { ingredientId: 'coconut-milk', name: 'Coconut milk', quantity: 400, unit: 'ml', category: 'pantry' },
      { ingredientId: 'onion', name: 'Onion', quantity: 1, unit: 'count', category: 'produce' },
      { ingredientId: 'spinach', name: 'Spinach', quantity: 160, unit: 'g', category: 'produce' },
      { ingredientId: 'rice', name: 'Rice', quantity: 300, unit: 'g', category: 'pantry' },
    ],
    tags: ['#batch-friendly', '#vegan'],
    dietaryTags: ['vegan', 'vegetarian', 'gluten-free'],
    styleTags: ['batch-prep', 'leftover-rotation', 'fresh-varied'],
  },
  {
    id: 'bean-chilli',
    name: 'Bean chilli bowls',
    mealTypes: ['dinner', 'lunch'],
    baseServings: 5,
    prepMinutes: 10,
    cookMinutes: 30,
    ingredients: [
      { ingredientId: 'kidney-beans', name: 'Kidney beans', quantity: 480, unit: 'g', category: 'pantry' },
      { ingredientId: 'tinned-tomatoes', name: 'Tinned tomatoes', quantity: 800, unit: 'g', category: 'pantry' },
      { ingredientId: 'onion', name: 'Onion', quantity: 1, unit: 'count', category: 'produce' },
      { ingredientId: 'pepper', name: 'Bell pepper', quantity: 2, unit: 'count', category: 'produce' },
      { ingredientId: 'tortilla-wraps', name: 'Tortilla wraps', quantity: 6, unit: 'count', category: 'bakery' },
    ],
    tags: ['#batch-friendly', '#lunchable'],
    dietaryTags: ['vegan', 'vegetarian'],
    styleTags: ['batch-prep', 'leftover-rotation'],
  },
  {
    id: 'egg-fried-rice',
    name: 'Egg fried rice',
    mealTypes: ['dinner', 'lunch'],
    baseServings: 3,
    prepMinutes: 8,
    cookMinutes: 14,
    ingredients: [
      { ingredientId: 'rice', name: 'Rice', quantity: 260, unit: 'g', category: 'pantry' },
      { ingredientId: 'eggs', name: 'Eggs', quantity: 4, unit: 'count', category: 'dairy' },
      { ingredientId: 'frozen-peas', name: 'Frozen peas', quantity: 180, unit: 'g', category: 'frozen' },
      { ingredientId: 'carrot', name: 'Carrot', quantity: 1, unit: 'count', category: 'produce' },
      { ingredientId: 'spring-onions', name: 'Spring onions', quantity: 3, unit: 'count', category: 'produce' },
    ],
    tags: ['#fast', '#leftover-rice'],
    dietaryTags: ['vegetarian', 'gluten-free'],
    styleTags: ['fresh-varied', 'leftover-rotation'],
  },
  {
    id: 'pasta-tomato-spinach',
    name: 'Tomato spinach pasta',
    mealTypes: ['dinner', 'lunch'],
    baseServings: 3,
    prepMinutes: 7,
    cookMinutes: 18,
    ingredients: [
      { ingredientId: 'pasta', name: 'Pasta', quantity: 300, unit: 'g', category: 'pantry' },
      { ingredientId: 'tinned-tomatoes', name: 'Tinned tomatoes', quantity: 400, unit: 'g', category: 'pantry' },
      { ingredientId: 'onion', name: 'Onion', quantity: 0.5, unit: 'count', category: 'produce' },
      { ingredientId: 'spinach', name: 'Spinach', quantity: 120, unit: 'g', category: 'produce' },
      { ingredientId: 'cheddar', name: 'Cheddar', quantity: 60, unit: 'g', category: 'dairy' },
    ],
    tags: ['#cheap', '#quick'],
    dietaryTags: ['vegetarian'],
    styleTags: ['fresh-varied'],
  },
  {
    id: 'tuna-potato-salad',
    name: 'Tuna potato salad',
    mealTypes: ['lunch', 'dinner'],
    baseServings: 2,
    prepMinutes: 8,
    cookMinutes: 18,
    ingredients: [
      { ingredientId: 'potatoes', name: 'Potatoes', quantity: 500, unit: 'g', category: 'produce' },
      { ingredientId: 'tuna', name: 'Tuna', quantity: 145, unit: 'g', category: 'pantry' },
      { ingredientId: 'eggs', name: 'Eggs', quantity: 2, unit: 'count', category: 'dairy' },
      { ingredientId: 'spinach', name: 'Spinach', quantity: 80, unit: 'g', category: 'produce' },
    ],
    tags: ['#protein', '#cold-lunch'],
    dietaryTags: ['gluten-free', 'keto'],
    styleTags: ['fresh-varied'],
  },
  {
    id: 'tofu-veg-traybake',
    name: 'Tofu veg traybake',
    mealTypes: ['dinner'],
    baseServings: 3,
    prepMinutes: 10,
    cookMinutes: 25,
    ingredients: [
      { ingredientId: 'tofu', name: 'Tofu', quantity: 280, unit: 'g', category: 'protein' },
      { ingredientId: 'potatoes', name: 'Potatoes', quantity: 650, unit: 'g', category: 'produce' },
      { ingredientId: 'carrot', name: 'Carrot', quantity: 2, unit: 'count', category: 'produce' },
      { ingredientId: 'onion', name: 'Onion', quantity: 0.5, unit: 'count', category: 'produce' },
    ],
    tags: ['#traybake', '#vegan'],
    dietaryTags: ['vegan', 'vegetarian', 'gluten-free'],
    styleTags: ['fresh-varied', 'leftover-rotation'],
  },
  {
    id: 'oats-banana',
    name: 'Banana peanut oats',
    mealTypes: ['breakfast'],
    baseServings: 1,
    prepMinutes: 4,
    cookMinutes: 4,
    ingredients: [
      { ingredientId: 'oats', name: 'Oats', quantity: 60, unit: 'g', category: 'pantry' },
      { ingredientId: 'banana', name: 'Banana', quantity: 1, unit: 'count', category: 'produce' },
      { ingredientId: 'peanut-butter', name: 'Peanut butter', quantity: 18, unit: 'g', category: 'pantry' },
    ],
    tags: ['#breakfast', '#cheap'],
    dietaryTags: ['vegan', 'vegetarian'],
    styleTags: ['fresh-varied', 'leftover-rotation', 'batch-prep'],
  },
];

const productBase = [
  ['red-lentils', 'Red lentils 500g', 1.55, 500, 'g', 'pantry'],
  ['tinned-tomatoes', 'Chopped tomatoes 400g', 0.65, 400, 'g', 'pantry'],
  ['onion', 'Brown onions 3 pack', 1.05, 3, 'count', 'produce'],
  ['carrot', 'Carrots 1kg', 0.75, 10, 'count', 'produce'],
  ['rice', 'Long grain rice 1kg', 1.35, 1000, 'g', 'pantry'],
  ['chickpeas', 'Chickpeas tin 400g drained 240g', 0.72, 240, 'g', 'pantry'],
  ['coconut-milk', 'Coconut milk 400ml', 0.99, 400, 'ml', 'pantry'],
  ['spinach', 'Baby spinach 200g', 1.49, 200, 'g', 'produce'],
  ['kidney-beans', 'Kidney beans tin 400g drained 240g', 0.69, 240, 'g', 'pantry'],
  ['pepper', 'Mixed peppers 3 pack', 1.89, 3, 'count', 'produce'],
  ['tortilla-wraps', 'Tortilla wraps 8 pack', 1.15, 8, 'count', 'bakery'],
  ['eggs', 'Free range eggs 6 pack', 1.65, 6, 'count', 'dairy'],
  ['frozen-peas', 'Frozen peas 900g', 1.29, 900, 'g', 'frozen'],
  ['spring-onions', 'Spring onions bunch', 0.79, 8, 'count', 'produce'],
  ['pasta', 'Pasta 500g', 0.95, 500, 'g', 'pantry'],
  ['cheddar', 'Cheddar 200g', 1.85, 200, 'g', 'dairy'],
  ['potatoes', 'Potatoes 2kg', 1.79, 2000, 'g', 'produce'],
  ['tuna', 'Tuna chunks 145g', 1.15, 145, 'g', 'pantry'],
  ['tofu', 'Firm tofu 280g', 2.1, 280, 'g', 'protein'],
  ['oats', 'Porridge oats 1kg', 1.1, 1000, 'g', 'pantry'],
  ['banana', 'Bananas loose', 0.22, 1, 'count', 'produce'],
  ['peanut-butter', 'Peanut butter 340g', 1.75, 340, 'g', 'pantry'],
] as const;

const storeMultipliers = {
  tesco: 1,
  aldi: 0.9,
  lidl: 0.92,
};

export const sampleProducts: ScrapedProduct[] = productBase.flatMap(
  ([ingredientId, productName, price, unitQuantity, unit, category]) =>
    (['tesco', 'aldi', 'lidl'] as const).map((storeId) => ({
      id: `${storeId}-${ingredientId}`,
      storeId,
      productName: `${storeId.toUpperCase()} ${productName}`,
      ingredientId,
      price: Number((price * storeMultipliers[storeId]).toFixed(2)),
      currency: 'EUR' as const,
      unitQuantity,
      unit,
      category,
      scrapedAt: new Date('2026-06-09T09:00:00.000Z').toISOString(),
    }))
);
